module.exports = __webpack_public_path__ + "media/images/landing/solutions/solution-3-3973398ccb263dd49ad6f7c5cbd5aa56.png";